import { InspectorEditableBlock } from "../CommonFields/InspectorEditableBlock";
import { getFinalPrice } from "../constants";
import { ProductObj } from "../Types";
import styles from "./BundlePreviewWrapper.module.css";
const ProductSubscriptionsPreview = ({
    product,
    setSelectedVariants,
    bundleConfig,
}: {
    product: ProductObj;
    setSelectedVariants: any;
    bundleConfig: any;
}) => {
    return (
        <>
            {product?.subscriptions &&
                product?.subscriptions?.length > 0 &&
                product.subscriptions.some((sub: any) => sub.checked == true) &&
                product?.oneTimePurchase &&
                !product.isSubscribed && (
                    <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="subscribeAndSaveMore">
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                product.isSubscribed = true;

                                const curSub =
                                    product.subscriptions &&
                                    product.subscriptions.find((sub: any) => sub.checked === true);

                                setSelectedVariants((prev: any) => {
                                    const updatedPlan = prev.map((v: any) => {
                                        return {
                                            ...v,
                                            selling_plan: curSub?.id,
                                            price: getFinalPrice(
                                                curSub?.discountType,
                                                curSub?.discountValue,
                                                v.copyPrice,
                                            ),
                                        };
                                    });
                                    return updatedPlan;
                                });
                            }}
                            className={styles.subscribeBtn}
                            style={{
                                backgroundColor: bundleConfig?.bundles_design?.add_to_cart_bg_color,
                                color: bundleConfig?.bundles_design?.add_to_cart_text_color,
                                width: "stretch",
                                textWrap: "wrap",
                                whiteSpace: "wrap",
                            }}
                        >
                            Subscribe and Save More
                        </button>
                    </InspectorEditableBlock>
                )}

            {product.isSubscribed && (
                <button
                    onClick={(e) => e.stopPropagation()}
                    className={styles.alreadySubscribed}
                    style={{
                        width: "max-content",
                    }}
                >
                    Subscribed
                </button>
            )}
        </>
    );
};

export default ProductSubscriptionsPreview;
